import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import VueAxios from "vue-axios";
import axios from "axios";
import "vuetify/dist/vuetify.min.css";
import "./assets/styles/styles.scss";
import "./router/permission";
// import "./api/httpClient";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-default.css";
import VueApexCharts from "vue-apexcharts";
import "@/utils/filters";
import "font-awesome/css/font-awesome.min.css";
import config from "./config";
import * as VueGoogleMaps from "vue2-google-maps";
import VCurrencyField from "v-currency-field";
Vue.config.productionTip = false;
import VueCountryCode from "vue-country-code";
import VueMask from "v-mask";
import { VueMaskFilter } from "v-mask";

Vue.use(VueApexCharts);
Vue.use(VueMask);
Vue.use(VueCountryCode);
Vue.filter("VMask", VueMaskFilter);
Vue.component("apexchart", VueApexCharts);
Vue.use(VueGoogleMaps, {
  load: {
    key: config.GOOGLE_MAPS_API,
    libraries: "places",
  },
});
Vue.use(VCurrencyField, {
  locale: "en",
  decimalLength: 2,
  autoDecimalMode: false,
  min: null,
  max: null,
  defaultValue: null,
});

Vue.use(VueAxios, axios);
Vue.use(VueToast, {
  position: "top",
  duration: 3000,
  dismissible: true,
  queue: true,
});

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
